var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3844_53331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.39967V11.8487H17.7778L15.5556 14.2976V21.6446H6.66667V4.50171H15.5556L17.7778 2.05273H1.11111C0.555556 2.05273 0 2.54253 0 3.27722V22.8691C0 23.4813 0.444444 24.0936 1.11111 24.0936H21.1111C21.6667 24.0936 22.2222 23.6038 22.2222 22.8691V6.95069L20 9.39967ZM4.44444 21.6446H2.22222V19.1956H4.44444V21.6446ZM4.44444 16.7466H2.22222V14.2976H4.44444V16.7466ZM4.44444 11.8487H2.22222V9.39967H4.44444V11.8487ZM4.44444 6.95069H2.22222V4.50171H4.44444V6.95069ZM20 21.6446H17.7778V19.1956H20V21.6446ZM20 16.7466H17.7778V14.2976H20V16.7466Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1109 13.3176H11.8887V9.88903L20.5553 0.33801C20.8887 -0.0293367 21.3331 -0.0293367 21.6664 0.33801L23.7776 2.66454C24.1109 3.03189 24.1109 3.52168 23.7776 3.88903L15.1109 13.3176Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3844_53331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.09375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryPrograms);
export default __webpack_public_path__ + "static/media/library-programs.6bfea2c7682c4d5fddbd614e605d9b2c.svg";
export { ForwardRef as ReactComponent };